import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { HeaderThemeEnum, LogoNavConfig, MainHeaderConfig, MenuConfig } from '../../../models/header-model';
import { NbMenuItem } from '@nebular/theme';

@Component({
  selector: 'ubs-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit,OnChanges {
  @Input() mainHeaderConfig:MainHeaderConfig;
  @Input() mainMenuConfig:MenuConfig;
  containsMainNav:boolean;
  logoNavConfig:LogoNavConfig;
  background:string;
  color:string;

  host:HTMLElement;
  menuHost:HTMLElement;

  themeEnum:HeaderThemeEnum;

  // @ViewChild('mainHeaderMenu') mainHeaderMenu:ElementRef<HTMLElement>

  

  constructor(private readonly viewRef: ViewContainerRef) { 
    this.host = this.viewRef.element.nativeElement;
  }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["mainHeaderConfig"]){
      //console.log({MainHederConfig:this.mainHeaderConfig});
      this.containsMainNav = this.mainHeaderConfig.containsMainNav;
      this.logoNavConfig = this.mainHeaderConfig.logoNavConfig;
      this.themeEnum = this.mainHeaderConfig.themeEnum?this.mainHeaderConfig.themeEnum:HeaderThemeEnum.DEFAULT;
      this.setHeaderTheme(this.themeEnum);
      //let styles = this.host.style.setProperty("--")
      if(this.themeEnum == HeaderThemeEnum.CUSTOM && this.mainHeaderConfig.background != undefined){
        this.background = this.mainHeaderConfig.background;
        this.host.style.setProperty("--header-background-color",this.background);
      }
      if(this.themeEnum == HeaderThemeEnum.CUSTOM && this.mainHeaderConfig.color != undefined){
        //console.log("setting the color",this.mainHeaderConfig.color);
        this.color = this.mainHeaderConfig.color;
        this.host.style.setProperty("--header-text-color",this.color);
      }
    }
  }

  setHeaderTheme(themeEnum:HeaderThemeEnum){
    switch (themeEnum) {
      case HeaderThemeEnum.DEFAULT:
        //console.log("It's themeEnum")
        this.host.classList.add('main-default');
        if(this.host.classList.contains('main-dark')) {
          console.log("Removing main Dark")
          this.host.classList.remove('main-dark')
        };
        if(this.host.classList.contains('main-custom')) this.host.classList.remove('main-custom');
        break;
      case HeaderThemeEnum.CUSTOM:
        this.host.classList.add('main-custom');
        if(this.host.classList.contains('main-dark')) this.host.classList.remove('main-dark');
        if(this.host.classList.contains('main-default')) this.host.classList.remove('main-default');
        break;
      case HeaderThemeEnum.DARK:
        this.host.classList.add('main-dark');
        if(this.host.classList.contains('main-custom')) this.host.classList.remove('main-custom');
        if(this.host.classList.contains('main-default')) this.host.classList.remove('main-default');
        break;
      default:
        console.log("Holy shit")
        break;
    }
  }

}
